import { routerInstance } from '@/router/router';
import { createPinia } from 'pinia';
import { markRaw } from 'vue';

export const pinia = createPinia();
pinia.use(({ store }) => {
  store.router = markRaw(routerInstance);
});
